import React, { useState, FC } from 'react'
import { WithQuestionnaires } from '../questionnaires/QuestionnaireProvider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import I18n from 'i18n'
import Info from '../atomic/atoms/Info'
import classNames from 'classnames'

interface Questionnaires {
  areEnabled: boolean | null | undefined
  oneTimeResponseUrl: (key: string) => string
  myOpenResponses?: Array<{ questionnaire: { key: string }, uuid: string }>
  openQuestionnaireUrlForUuid: (uuid: string) => string
}

interface Props {
  hideActiefTransport?: boolean
  withContainer?: boolean
  widerButton?: boolean
  questionnaires?: Questionnaires
}

const ActiefTransportButton: FC<Props> = ({
  hideActiefTransport = false,
  withContainer = false,
  widerButton = false,
  questionnaires
}) => {
  const [actiefTransportEnabled] = useState(true)

  if (hideActiefTransport || questionnaires?.areEnabled !== true) {
    return null
  }

  const actiefTransportResponse = questionnaires?.myOpenResponses?.find(
    response => response.questionnaire.key === 'actief_transport'
  )

  if (actiefTransportResponse == null) {
    return null
  }

  const link = questionnaires.openQuestionnaireUrlForUuid(actiefTransportResponse.uuid)

  const buttonClasses = classNames(
    'waves-effect text-m waves-light button-primary text-primary-color background-background text-medium',
    withContainer && 'button welcome-container-button',
    !withContainer && 'data-button data-detail-page',
    widerButton && 'wider-data-button'
  )

  const Button: FC = () => (
    <a className={buttonClasses} href={link} aria-disabled={!actiefTransportEnabled}>
      <FontAwesomeIcon icon='calendar-week' className='button-icon' />
      {I18n.t('components.welcome.fill_out_sportpro_wekelijks_logboek')}
      <Info
        text={I18n.t('components.welcome.fill_out_sportpro_wekelijks_logboek_tooltip')}
        tooltipId='fill-out-sportpro-logboek-tooltip'
      />
    </a>
  )

  return withContainer
    ? (
      <div className='col s6 m12'>
        <Button />
      </div>
      )
    : (
      <Button />
      )
}

export default WithQuestionnaires(ActiefTransportButton)
